module.exports = __webpack_public_path__ + "img/adulto22.5f17137d.jpg";